import React from "react";
import { useToast } from "../../context/ToastContext";
import ScheduleFeedList from "./ScheduleFeedList";
import useScheduleFeed from "./useScheduleFeed";

/* "Schedule & Calendar" card, third in the analytics grid: upcoming jobs, meetings and tasks, loaded as it scrolls. */
export default function ScheduleWidget({ version, canAdd, onOpenCalendar, onOpenDay, onAdd }) {
  const showToast = useToast();
  const feed = useScheduleFeed({ version, showToast });

  return (
    <div className="analytics-card schedule-widget-card">
      <div className="card-header-sm">
        <div className="card-header-info">
          <h3>📅 Schedule &amp; Calendar</h3>
          <span className="chart-subtext">Upcoming jobs, meetings &amp; tasks</span>
        </div>
        <button type="button" className="btn-widget-calendar" title="Open Full Calendar Schedule Dashboard" onClick={() => onOpenCalendar()}>
          Calendar ↗
        </button>
      </div>
      <ScheduleFeedList
        feed={feed}
        className="schedule-widget-body"
        itemClassName="schedule-widget-item-simple"
        onOpen={onOpenDay}
        empty={
          <div className="schedule-widget-empty">
            <span>📅 No upcoming schedule items.</span>
            {canAdd && (
              <button type="button" className="btn-widget-calendar" onClick={() => onAdd("job")}>
                + Add Schedule
              </button>
            )}
          </div>
        }
      />
    </div>
  );
}
